export default {
	generals: {
		login: 'Entrar',
		reset_password: 'Restablecer contraseña',
		sign_up: 'Regístrate',
		write_something: 'Escribe algo',
	},
	packages: {
		dashboard: 'Dashboard',
		management: 'Gestión',
		projects: 'Proyectos',
		cms: 'CMS',
	},
	resources: {
		comments: 'Comentarios',
		profile: {
			skills: 'habilidades',
			equipment: 'equipamiento',
			name: 'nombre',
		},
		products: {
			product: 'producto | productos',
			attribute: 'atributo | atributos',
			type_field: 'tipo de campo',
			value: 'valor',
			operable: 'operable',
			base_price: 'precio base',
			sale_price: 'precio venta',
			purchase_price: 'precio compra',
			price: 'precio',
			taxes: 'impuestos',
			save: 'ahorro',
			discount: 'descuento',
			total: 'total',
			total_measurement_unit: 'medidas totales',
			alerts: {
				min_value: 'valor mínimo',
				max_value: 'valor máximo',
			},
			unit_price: 'p. unitario',
		},
		tasks: {
			task: 'tarea | tareas',
		},
		categories: {
			category: 'categoría',
		},
		budgets: {
			budget: 'presupuesto',
		},
		orders: {
			order: 'pedido'
		},
		invoices: {
			invoice: 'factura'
		},
		partners: {
			partner: 'colaborador | colaboradores',
		},
	},
	interface: {
		save: 'guardar',
		new: 'nuevo | nuevos | nueva | nuevas',
		detail: 'detalle | detalles',
		setting: 'configuración | configuraciones',
		image: 'imagen | imágenes',
		doc: 'documento | documentos',
		title: 'título | títulos',
		short_title: 'título corto',
		description: 'descripción | descripciones',
		short_description: 'descripción corta',
		keywords: 'tags',
		status: 'estado | estados',
		email_address: 'correo',
		password: 'contraseña',
		print: 'imprimir',
		fiscal_data: 'datos fiscales',
		lock: 'bloquear',
		unlock: 'desbloquear',
		payment_conditions: 'condiciones de pago',
		send: 'enviar',

		actions: {
			show: 'Ver',
			edit: 'Editar',
			call: 'Llamar',
			add: 'Añadir',
			quit: 'Quitar',
			search: 'Buscar',
			select: 'Seleccionar',
		},

		datatable: {
			info_template: 'Mostrando registros del {from} al {to} de un total de {total} registros',
			no_data_template: 'No se encontraron resultados',
			records_per_page: 'Registros por página',
		}
	},
	messages: {
		done: 'Hecho',
		attention: 'Atención',
		notify: 'Notificar',

		cant_deleted: 'No se puede eliminar',
		item_can_not_be_retrieved: 'El item no se podrá recuperar',

		the_dates_are_incorrect: 'Las fechas son incorrectas',
		notify_the_task_staff_by_email: 'Notificar por e-mail al personal de la tarea',
		notifications_sent_correctly: 'Notificaciones enviadas correctamente',
		task_has_closures_of_users_clients: 'La tarea tiene cierres de usuarios y/o de clientes',
		notifications_be_marked_read: 'Las notificaciones se marcarán como leídas',
		actions_be_applied_selected_items: 'Se aplicarán las acciones a los items seleccionados',
		closure_be_made: 'Se realizará este cierre',
		staff_has_tasks_on_dates: 'El personal tiene tareas asignadas en estas fechas',

		the_schedule_will_be_marked_as_done: 'El horario será marcado como completado',
		the_schedule_will_be_marked_as_not_done: 'El horario será marcado como NO completado',

		budget_will_be_created: 'Se creará un presupuesto',
		formula_will_be_created: 'Se creará una formula',

		purchase_orders_will_be_added: 'Se añadirán los pedidos de compras',
		purchase_order_will_be_added: 'Se añadirá un pedido de compra',
	},
	settings: {
		docs: {
			'budget-show': 'Vista presupuesto',
			'budget-edit': 'Editar presupuesto',
			'budget-pdf': 'PDF presupuesto',
			'order-show': 'Vista pedido',
			'order-edit': 'Editar pedido',
			'invoice-show': 'Vista factura',
			'invoice-edit': 'Editar factura',
			'invoice-pdf': 'PDF factura',
			'agreement-show': 'Vista contrato',
			'agreement-edit': 'Editar contrato',
			'delivery-note-show': 'Vista albarán',
			'delivery-note-edit': 'Editar albarán',
			'delivery-note-pdf': 'PDF albarán',
		}
	},
	breadcrumb: {
		'management': 'gestión',
		'cms': 'cms',
		'projects': 'proyectos',
		'customers': 'clientes',
		'edit': 'editar',
		'billings': 'datos fiscales',
		'docs': 'documentos',
		'budgets': 'presupuestos',
		'orders': 'pedidos',
		'invoices': 'facturas',
		'activity': 'actividad',
		'requests': 'solicitudes',
		'providers': 'proveedores',
		'sales': 'ventas',
		'purchases': 'compras',
		'products': 'productos',
		'categories': 'categorias',
		'reports': 'reportes',
		'users': 'usuarios',
		'departments': 'departamentos',
		'settings': 'configuraciones',
		'accounts': 'cuentas',
		'qr-reader': 'lector qr',
		'create': 'crear',
		'articles': 'artículos',
		'maps': 'mapas',
		'teams': 'equipos',
		'tasks': 'tareas',
		'calendar': 'calendario',
		'agreements': 'contratos',
		'recurrings': 'recurrentes',
		'attributes': 'atributos',
		'incidents': 'incidentes',
		'comments': 'comentarios',
		'paymentconditions': 'Condiciones de pago',
		'deliverynotes': 'Albaranes',
	}
}


// WEBPACK FOOTER //
// ./src/packages/lang/languages/es.js